import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import { FormControlLabel, InputAdornment, TextField } from '@mui/material';
import styles from './MultipleSectionInput.module.scss';

const useStyles = makeStyles(() => ({
  innerInput: {
    border: 'none',
  },
}));

interface MultipleSectionInputProps {
  id: string;
  label: ReactNode | string;
  disabled?: boolean;
  className?: string;
  firstSectionLabel: string;
  firstSectionValue: string;
  secondSectionLabel: string;
  secondSectionValue: string;
}

const MultipleSectionInput: React.FC<MultipleSectionInputProps> = (props) => {
  const { id, label, disabled, className, firstSectionLabel, firstSectionValue, secondSectionLabel, secondSectionValue } = props;
  const classes = useStyles();

  return (
    <Box
      id={id}
      display="flex"
      flexDirection="column"
      className={className}
      border={1}
      borderColor="grey.400"
      borderRadius={1}
    >
      <label htmlFor="input-first-section" className={styles.MultipleLabel}>{label}</label>
      <FormControlLabel
        label=""
        className={styles.FormLabel}
        control={(
          <TextField
            id="input-first-section"
            disabled={disabled}
            multiline
            minRows={2}
            fullWidth
            value={firstSectionValue || ''}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <span className={`self-end ${styles.InputPadStart}`}>
                    {firstSectionLabel}
                  </span>
                </InputAdornment>
              ),
              classes: { notchedOutline: classes.innerInput },
            }}
          />
        )}
      />
      <div className={styles.Separator} />
      <FormControlLabel
        label=""
        className={styles.FormLabel}
        control={(
          <TextField
            id="input-second-section"
            multiline
            disabled={disabled}
            minRows={2}
            value={secondSectionValue}
            fullWidth
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <span className={`self-end ${styles.InputPadStart}`}>
                    {secondSectionLabel}
                  </span>
                </InputAdornment>
              ),
              classes: { notchedOutline: classes.innerInput },
            }}
          />
        )}
      />
    </Box>
  );
};

export default MultipleSectionInput;
